import React, { lazy } from "react";

export const ViewVehicleDetailsMetadata = {
  name: "View Vehicle Details",
  id: "view_vehicle_details",
  component: lazy(() => import("../VehicleManagement/ViewVehicleDetailsComponent")),
  route: "/view_vehicle_details",
  Breadcrumbs: true,
};
